/* Local playback controls for FA video; reconnects after theme-editor renders. */
if (!customElements.get('fa-video')) {
  customElements.define('fa-video', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-fa-video-action]');
        const player = this.querySelector('video, iframe');
        if (!button || !player) return;
        const play = button.dataset.faVideoAction === 'play';
        if (player.tagName === 'VIDEO') {
          if (play) player.play().catch(() => { /* Browser may reject playback. Allow retry. */ });
          else player.pause();
          return;
        }
        const youtube = player.classList.contains('js-youtube');
        const command = youtube
          ? { event: 'command', func: play ? 'playVideo' : 'pauseVideo', args: [] }
          : { method: play ? 'play' : 'pause' };
        const origin = youtube ? 'https://www.youtube.com' : 'https://player.vimeo.com';
        player.contentWindow.postMessage(JSON.stringify(command), origin);
      }, { signal: this.abortController.signal });
      this.observer = new MutationObserver(() => this.showControls());
      this.observer.observe(this, { childList: true, subtree: true });
      this.showControls();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
    }

    showControls() {
      const controls = this.querySelector('[data-fa-video-controls]');
      if (controls) controls.hidden = !this.querySelector('video, iframe');
    }
  });
}
